<template>
  <div v-show="this.data.length !== 0" style="height: 500px">
    <h3>{{tableType}}</h3>
    <div class="dataset_celltype">
      <div class="left2">
        <div :id="vue_div" style="height: 400px;width: 400px"/>
      </div>
      <div class="right2" v-if="loadTable">
        <el-table
            stripe
            border
            max-height="400"
            size="mini"
            style="width: 100%"
            :data="data.slice((pageinfo.currentPage-1)*pageinfo.pageSize,pageinfo.currentPage*pageinfo.pageSize)">
          <el-table-column prop="spot" label="spot" sortable show-overflow-tooltip fixed="left" min-width="200"></el-table-column>
          <div v-for="(item,index) in columns" :key="index">
            <el-table-column :prop="item" :label="item" sortable show-overflow-tooltip
                             :formatter="rounding"></el-table-column>
          </div>
        </el-table>
        <!-- 分页器 -->
        <el-pagination align='center' @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="pageinfo.currentPage"
                       :page-sizes="[10,20,50,100]"
                       :page-size="pageinfo.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="data.length">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts/core";

export default {
  name: "PicTableCard",
  data (){
    return{
      formData: {
        datasetID: '',
        Array: '',
      },
      data: [],
      columns: [],
      list_data: {},
      type: '',
      pageinfo: {
        currentPage: 1,
        pageSize: 10
      },
      vue_div: '',
      loadTable: false,
    }
  },
  props:{
    position: Array,
    tableType: String,
    datasetID: Number,
    Array: String,
  },
  mounted() {
    this.vue_div = this.tableType + '_vue'
    this.formData.datasetID = this.datasetID
    this.formData.Array = this.Array
    this.getTableData()
    setTimeout(()=>{
      this.loadTable = true
    }, 1000)
  },
  methods: {
    getTableData() {
      let _this = this
      console.log(_this.formData.datasetID + '/' + _this.formData.Array)
      _this.$axios.get(
          'http://' + _this.$global.serverIP + ':' + _this.$global.serverHost + '/celltype/'+ _this.tableType +'/' + _this.formData.datasetID + '/' + _this.formData.Array)
          .then(function (response) {
            // console.log(_this.tableType + ':')
            // console.log(response)
            _this.data = eval('(' + response.data.data + ')')
            // console.log(_this.data)
            _this.processData()
            _this.initEcharts()
          })
    },
    processData() {
      let _this = this
      let temp = _this.data[0]
      // console.log(temp)
      let keyData = Object.keys(temp)
      _this.columns = []
      for (let i = 0; i < keyData.length; i++) {
        if (keyData[i] !== 'spot' && keyData[i] !== 'x' && keyData[i] !== 'y') {
          _this.columns.push(keyData[i])
        }
      }
      console.log(_this.columns)
    },
    initEcharts() {
      this.changeJSONObject2Array()
      let _this = this
      let elementID = _this.vue_div
      // console.log(elementID)
      const chartDom = document.getElementById(elementID);
      const myChart = echarts.init(chartDom);
      let option;
      const schema = [
        {name: 'no', index: 0, text: 'no'},
        {name: 'x', index: 1, text: 'x'},
        {name: 'y', index: 2, text: 'y'},
        {name: 'spot', index: 3, text: 'spot'},
        {name: 'expression', index: 4, text: 'expression'},
      ];
      const itemStyle = {
        emphasis: {
          focus: 'self'
        }
      };

      let _selected = {};
      let _series = []
      for (let i in _this.columns) {
        let temp = {
          type: 'scatter',
          itemStyle: itemStyle,
          large: true,                //是否开启大规模散点图的优化，在数据图形特别多的时候（>=5k）可以开启。开启后配合 largeThreshold 在数据量大于指定阈值的时候对绘制进行优化。缺点：优化后不能自定义设置单个数据项的样式。
          largeThreshold: 5000,        //开启绘制优化的阈值。
          data: this.list_data[_this.columns[i]],
          symbolSize: 3,
          name: _this.columns[i],
        }
        _series.push(temp)
        if (i === 0) {
          _selected[_this.columns[i]] = true
        } else {
          _selected[_this.columns[i]] = false
        }
      }
      option = {
        color: ['#FF0000', '#FF8000', '#FFFF00', '#80FF00', '#00FF00', '#00FF80', '#00FFFF',
          '#0080FF', '#0000FF', '#7F00FF', '#FF00FF', '#FF007F', '#808080', '#FF7F7F'],
        toolbox: {
          top: 20,
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage: {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        legend: {
          type: 'scroll',
          x: 'center',
          y: 'top',
          data: _this.columns,
          selectedMode: "single", // 单选
          selected: _selected,
          textStyle: {
            fontSize: 10
          }
        },
        // grid: {
        //   left: '15%',
        //   right: '15%',
        //   top: '5%',
        //   bottom: '5%'
        // },
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          formatter: function (param) {
            // console.log(param)
            var value = param.value;
            // prettier-ignore
            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                + param.seriesName
                + '</div>'
                // + schema[0].text + '：' + value[2] + '<br>'
                + schema[1].text + ': ' + value[0] + '<br>'
                + schema[2].text + ': ' + value[1] + '<br>'
                + schema[3].text + ': ' + value[3] + '<br>'
                + schema[4].text + ': ' + value[4] + '<br>';
          }
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 10,
          nameTextStyle: {
            fontSize: 10
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 10,
          nameTextStyle: {
            fontSize: 10
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        visualMap: [
          {
            left: 'right',
            bottom: '30%',
            dimension: 4,
            type: 'continuous',
            calculable: true,                        //是否显示拖拽用的手柄（手柄能拖拽调整选中范围）
            realtime: true,                          //拖拽时，是否实时更新
            precision: 3,                            //数据展示的小数精度，默认为0，无小数点
            min: 0,
            max: 1,
            itemHeight: 120,
            align: "auto",
            text: ['expression'],
            textGap: 10,
            inRange: {
              // colorLightness: [1, 0.4],
              // color: ['#d9d9d9','blue']
              color: ['blue', 'yellow', 'red']
            },
            outOfRange: {
              color: ['rgba(255,255,255,0.4)']
            },
            controller: {
              inRange: {
                // color: ['#d9d9d9','blue']
                color: ['blue', 'yellow', 'red']
                // color: ['#c23531']
                // color: ['#FFFFFF']
              },
              outOfRange: {
                color: ['#999']
              }
            }
          }
        ],
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        series: _series
      };
      myChart.off('legendselectchanged') //解决重复触发
      myChart.on('legendselectchanged', function (params) {
        // console.log('点击了', params.name);
        _this.type = params.name;
        _this.changeSelect()
      });
      option && myChart.setOption(option);
    },
    changeSelect() {
      let _this = this
      let elementID = "rctd_vue"
      // console.log(_this.type)
      const itemStyle = {
        emphasis: {
          focus: 'self'
        }
      };
      let _series = []
      for (let i in _this.columns) {
        let temp = {
          type: 'scatter',
          itemStyle: itemStyle,
          large: true,                //是否开启大规模散点图的优化，在数据图形特别多的时候（>=5k）可以开启。开启后配合 largeThreshold 在数据量大于指定阈值的时候对绘制进行优化。缺点：优化后不能自定义设置单个数据项的样式。
          largeThreshold: 5000,        //开启绘制优化的阈值。
          data: this.list_data[_this.columns[i]],
          symbolSize: 3,
          name: _this.columns[i],
        }
        _series.push(temp)
      }
      const myChart = echarts.getInstanceByDom(document.getElementById(elementID));
      // let option;
      myChart.setOption({
        legend: {selected: {[_this.RCTD.type]: true}},
        series: _series
      })
      // chartDom.setAttribute('_echarts_instance_', '')
      // option && myChart.setOption(option,true);
    },
    changeJSONObject2Array() {
      let _this = this
      let res = {}
      let res_list = []
      console.log(_this.position)
      for (let i = 0; i < _this.columns.length; i++) {
        res_list.push([])
      }
      for (let i in _this.data) {
        // console.log(i)
        let temp_array = _this.data[i]
        let index = _this.position.findIndex(item => item.spot === temp_array.spot)
        if (index !== -1 && _this.position[index].x !== '' && _this.position[index].x !== null) {
          for (let j in _this.columns) {
            let res_array = []
            let temp_type = _this.columns[j]
            res_array.push(_this.position[index].x)
            res_array.push(_this.position[index].y)
            res_array.push(Number(j))
            res_array.push(temp_array['spot'])
            res_array.push(temp_array[temp_type])
            res_list[j].push(res_array)
          }
        }
      }
      for (let j in _this.columns) {
        let temp_type = _this.columns[j]
        res[temp_type] = res_list[j]
      }
      _this.list_data = res
      console.log(_this.list_data)
    },
    handleSizeChange(val) {
      this.pageinfo.currentPage = 1;
      this.pageinfo.pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.pageinfo.currentPage = val;
    },
    rounding(row, column) {
      return parseFloat(row[column.property]).toFixed(8)
    },
  }
}
</script>

<style scoped>
.dataset_celltype {
  width: 100%;
  display: flex;
  /*flex-direction: column;*/
  justify-content: center;
  align-items: center;
}
.left2 {
  height: 450px;
  width: 450px;
  z-index: 99;
}

.right2 {
  height: 450px;
  flex: 1;
  z-index: 99;
}
</style>
